import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type FileKeyContextValue = {
  fileKey: string | undefined;
  setFileKey: (key: string | undefined) => void;
  clear: () => void;
};

const FileKeyContext = createContext<FileKeyContextValue | undefined>(
  undefined,
);

export function useFileKey() {
  const [fileKey, setFileKey] = useState<string | undefined>();

  const clear = useCallback(() => {
    setFileKey(undefined);
  }, []);

  return useMemo(
    () => ({
      fileKey,
      setFileKey,
      clear,
    }),
    [clear, fileKey],
  );
}

export function FileKeyProvider({ children }: { children: ReactNode }) {
  const r = useFileKey();

  return (
    <FileKeyContext.Provider value={r}>{children}</FileKeyContext.Provider>
  );
}

export function useFileKeyContext() {
  return useContext(FileKeyContext);
}
